import * as S from "./ModalAlarmChart.style";
import { Legend } from "../../Legends";
import { ModalProps, Modals } from "..";
import { Buttons } from "../../../atoms/Buttons";
import { LineSectionChart } from "../../../atoms/Charts/LineSectionChart";
import { EquipmentDefaultValuesTypes } from "../../../../types/equipment";
import { ReactComponent as IconArrow } from "../../../../styles/assets/svg/icon_title_arrow.svg";

interface ModalAlarmChartProps extends ModalProps {
  search?: EquipmentDefaultValuesTypes;
  chartData?: any;
}

export const ModalAlarmChart = (props: ModalAlarmChartProps) => {
  return (
    <Modals
      modalTitle="알람 차트"
      modalButtons={
        <Buttons
          type="button"
          size="md"
          layout="secondary"
          label="닫기"
          onClick={() => props.setModalShow(false)}
        />
      }
      setModalShow={props.setModalShow}
    >
      <S.AlarmChart>
        <S.AlarmChartTitle>센서 상태진단 알람통계 차트</S.AlarmChartTitle>
        <S.AlarmChartStatus>
          <div>
            {props.search?.mcyName}
            <IconArrow />
            {props.search?.lowMcyName}
            <IconArrow />
            {props?.chartData?.sensorName}
          </div>
          <Legend title="검색 주기" type="uptime">
            <>
              {props.search?.startDate} ~ {props.search?.endDate}
            </>
          </Legend>
        </S.AlarmChartStatus>

        {props?.chartData ? (
          <S.AlarmChartContent>
            {/* 센서 상태진단 알람통계 차트 */}
            <LineSectionChart chartData={props?.chartData?.result} />
          </S.AlarmChartContent>
        ) : (
          <div>데이터가 없습니다.</div>
        )}
      </S.AlarmChart>
    </Modals>
  );
};
